module.exports = __webpack_public_path__ + "img/catering_menu_13.53b427b3.jpg";